import { Route, Link, BrowserRouter as Router, Routes } from "react-router-dom";
import PrivacyPolicyComponent from "./components/documents/privacyPolicyComponent";
import TermsOfServiceComponent from "./components/documents/termsOfServiceComponent";
import AppointmentListPageComponent from "./pages/appointmentsListPage";
import CreateBookingPageComponent from "./pages/createBookingPage";
import MainPageComponent from "./pages/mainPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPageComponent />} />
        <Route path="/zakazivanje" element={<CreateBookingPageComponent />} />
        <Route path="/mojitermini" element={<AppointmentListPageComponent />} />
        <Route path="/privacy" element={<PrivacyPolicyComponent />} />
        <Route path="/terms" element={<TermsOfServiceComponent />} />
        <Route path="*" element={<MainPageComponent />} />
      </Routes>
    </Router>
  );
}

export default App;
